<div class="sidebar-container">
  <nav *ngIf="opened && items.length" class="sidebar bg-white no-print" [style.top.px]="topOffset" @showMenu>
    <ng-scrollbar #sidebarScroll="ngScrollbar"
      style="max-height: 100%; padding-bottom: 60px;"
      (scrolled)="closeSubMenu(true)"
    > 
      
      <ul class="flex-column navbar-nav w-100 justify-content-between">
        <li *ngFor="let item of items; trackBy: menuItemTrackBy" class="nav-item d-block">
          <ng-template [ngTemplateOutlet]="menuLink" [ngTemplateOutletContext]="{ item: item }"></ng-template>
        </li>
      </ul>
    </ng-scrollbar>

    <!-- sidebas sub menu items -->
    <div
      *ngIf="subMenuItem && subMenuItem.children.length"
      class="sub-menu"
      [style.top.px]="subMenuTop"
      #subMenu
      [@showSubMenu]="{
        params: {
          previousTop: subMenuPreviousTop
        }
      }"
    >
      <span class="arrow" [style.margin-top.px]="subMenuOverflowFix"></span>
      <span class="sub-menu-title">{{ subMenuItem.title }}</span>
      <ul>
        <li *ngFor="let child of subMenuItem.children">
          <a
            [routerLink]="child.link"
            routerLinkActive="active-link"
            id="{{ getSubTitleIdBySubTitleCode(child) }}"
            (click)="child.clickHandler(child.code, $event)"
          >
            {{ child.title }}
          </a>
        </li>
      </ul>
    </div>
  </nav>
</div>

<ng-template #menuLink let-item="item">
  <ng-container [ngSwitch]="item.item_type">
    <a
      *ngSwitchCase="'external_link'"
      target="_blank"
      rel="noopener noreferrer"
      [href]="item.external_link"
      class="nav-link"
    >
      <svg>
        <use [attr.xlink:href]="item.ico"></use>
      </svg>
      <span class="text-truncate">{{ item.title }}</span>
    </a>

    <a
      *ngSwitchCase="'title'"
      (click)="titleClick($event.currentTarget, item)"
      class="nav-link"
      id="nav-{{ item.code }}"
      [ngClass]="{ 'active-link': titleIsActive(item), opened: item.opened }"
    >
      <svg>
        <use [attr.xlink:href]="item.ico"></use>
      </svg>
      <span>{{ item.title }}</span>
    </a>

    <a
      *ngSwitchDefault
      [routerLink]="[item.link]"
      id="nav-{{ item.code }}"
      routerLinkActive="active-link"
      class="nav-link"
    >
      <svg>
        <use [attr.xlink:href]="item?.ico"></use>
      </svg>
      <span>{{ item.title }}</span>
    </a>
  </ng-container>
</ng-template>
